export default __webpack_public_path__ + "static/media/anytime-giftcard1.e93c3969.webp";